import { FORM_TYPE_LAB_TEST } from '@/utils/constants'
import { createSlice } from '@reduxjs/toolkit'

const commonInitialState = {
  cartModalIsOpen: false,
  itemToRemoveFromCart: {},
  selectedTimeSlot: '',
  requestCallbackModalIsOpen: {
    type: FORM_TYPE_LAB_TEST,
    modalIsOpen: false,
  },
  userOnboardingModalIsOpen: false,
  commonCenterModalData: {
    commonCenterModalIsOpen: false,
    message: '',
    description: '',
    smilingEmoticon: false,
    error: false,
    noIcon: false,
    callNumber: '',
  },
  globalLoaderIsOpen: false,
  updatedCityUuid: '',
  invisibleLoaderIsOpen: false,
  pincodeNotServicableModalIsOpen: false,

  stickyBottomBarCount: 0,
}
const commonSlice = createSlice({
  name: 'cartDataReducer',
  initialState: commonInitialState,
  reducers: {
    updateCommonReducerData: (state, action) => {
      state.cartModalIsOpen = action.payload.modalIsOpen
      state.itemToRemoveFromCart = action.payload.activePatientDetailDto
      state.selectedTimeSlot = action.payload.selectedTimeSlot
      state.requestCallbackModalIsOpen =
        action.payload.requestCallbackModalIsOpen
      state.userOnboardingModalIsOpen = action.payload.userOnboardingModalIsOpen
      state.commonCenterModalData = action.payload.commonCenterModalData
      state.globalLoaderIsOpen = action.payload.globalLoaderIsOpen
      state.updatedCityUuid = action.payload.updatedCityUuid
      state.invisibleLoaderIsOpen = action.payload.invisibleLoaderIsOpen
      state.pincodeNotServicableModalIsOpen =
        action.payload.pincodeNotServicableModalIsOpen
    },
    registerStickyBottomBar: (state) => {
      state.stickyBottomBarCount += 1
    },
    unregisterStickyBottomBar: (state) => {
      state.stickyBottomBarCount = Math.max(0, state.stickyBottomBarCount - 1)
    },
  },
})
export const {
  updateCommonReducerData,
  registerStickyBottomBar,
  unregisterStickyBottomBar,
} = commonSlice.actions
export default commonSlice.reducer
